<template>
    <span>
        <signin-button />
        <br>
        <br>
        <router-view v-if="slack_is_signed_in" />
    </span>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SigninButton from '../../modules/slack/components/SigninButton.vue'
export default {
    computed: {
        ...mapGetters(['slack_is_signed_in',]),
    },
    components: {
        SigninButton,
    }
}
</script>